module.exports = __webpack_public_path__ + "img/puzzle_21.5b36dc42.png";